// extracted by mini-css-extract-plugin
export default {"sportsMenuTabList":"SportsMenuTabList_sportsMenuTabList__UVDEh","submenuTabItem":"SportsMenuTabList_submenuTabItem__HVWDQ"};